// extracted by mini-css-extract-plugin
export default {"errorList":"QuantityInput_errorList__eyO2t"};